import { NavigationItem } from "@/modules/common/features/navigation/model/types";
import { SHIFT_LIST_PAGE_PATH } from "@/modules/timesheet/pages/shift-list-page";
import {
  ClockCircleOutlined,
  ScheduleOutlined,
  TableOutlined,
} from "@ant-design/icons";
import { AllTokens, EnabledTokens } from "gql/graphql";
import { HR } from "@/shared/modules/constants/modules-id";
import { TIMESHEET_PATH } from "@/modules/timesheet/pages/timesheet";

export const timesheetMenu: NavigationItem = {
  label: "timesheet group",
  icon: <ClockCircleOutlined />,
  requiredModule: HR,
  children: [
    {
      label: "shifts",
      to: SHIFT_LIST_PAGE_PATH,
      icon: <ScheduleOutlined />,
      requiredAtLeastOnePermission: [AllTokens.TimesheetShifts],
    },
    {
      label: "timesheet",
      to: TIMESHEET_PATH,
      icon: <TableOutlined />,
      requiredAtLeastOnePermission: [EnabledTokens.TimesheetTimesheets],
    },
  ],
};
